import { MarketplaceValue } from "@/components/tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
export default {
  name: "MarketplaceFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    name: {
      type: String
    },
    icon: {
      type: String
    },
    selected: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    },
    // Search term to highlight within the marketplace label.
    query: {
      type: String,
      default: ""
    },
    no_reset: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MarketplaceValue,
    HighlightTextValue,
    WrapWithSectionItem
  }
};